import { render, staticRenderFns } from "./B2BOrders.vue?vue&type=template&id=3c8cee2a&"
import script from "./B2BOrders.vue?vue&type=script&lang=js&"
export * from "./B2BOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports